import { render, staticRenderFns } from "./exchange-tab.vue?vue&type=template&id=7bdc584c&"
import script from "./exchange-tab.vue?vue&type=script&lang=js&"
export * from "./exchange-tab.vue?vue&type=script&lang=js&"
import style0 from "./exchange-tab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "exchange-tab.vue"
export default component.exports